import { Box, Grid, Typography } from '@mui/material'
import React from 'react'
import { useTheme } from '@emotion/react'
import { BRAND_NAME } from '../constants'
import { useNavigate } from 'react-router-dom'

const Navbar = () => {
    const theme = useTheme()
    const navigate = useNavigate()
    return (
        <div>
            <Box bgcolor={theme.palette.mode === "dark" ? "#1a297a" : "background.primary"} sx={{ boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)", padding: "12px 20px", }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => { navigate('/') }}>
                        <Box sx={{ pt: 1 }}>
                            <img src={process.env.PUBLIC_URL + "/assets/logo.png"} alt="Primeophoto logo" style={{ maxWidth: "40px", }} />
                        </Box>
                        <Box>
                            <Typography color={"primary.contrastText"} sx={{ fontSize: "20px", marginLeft: "10px" }}>{BRAND_NAME}</Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </div >
    )
}

export default Navbar